module.exports = __webpack_public_path__ + "img/scene_true_color_big@2x.cf536561.png";